export const DEFAULT_PROPERTY_CATEGORY = 'Basic Settings';
